export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '成91平台是什么？',
    answer: '成91是一个备受关注的综合性热门平台，集成了内容浏览、社区互动、数据分析等多种功能。平台致力于为用户提供优质、便捷的数字化服务体验，通过持续创新和技术升级，不断优化和完善平台功能。无论您是普通用户还是专业创作者，都能在成91找到适合自己的使用方式。'
  },
  {
    question: '如何注册成91账号？',
    answer: '注册成91账号非常简单快捷。您只需访问成91官网，点击右上角的注册按钮，填写手机号或邮箱地址并设置密码即可完成注册。整个注册过程仅需1-2分钟。注册成功后，建议您完善个人资料，以获得更加个性化的平台体验。'
  },
  {
    question: '成91平台是免费的吗？',
    answer: '成91平台的基础功能完全免费，所有注册用户都可以无限制地使用核心功能，包括内容浏览、社区互动、基础数据分析等。对于有更高需求的用户，成91也提供了高级会员服务，提供更多专属功能和权益。但基础免费功能已经能够满足绝大多数用户的使用需求。'
  },
  {
    question: '成91平台有哪些核心功能？',
    answer: '成91平台的核心功能包括：智能内容推荐系统、个性化用户界面定制、社区互动与社交功能、强大的数据分析工具、内容创作与管理工具、安全隐私保护机制等。平台还持续推出新功能，如AI智能助手、批量操作工具等，不断丰富用户体验。'
  },
  {
    question: '成91平台的用户数据安全吗？',
    answer: '成91平台高度重视用户数据安全，采用业界领先的数据加密技术保护所有用户数据。平台严格遵守相关法律法规，制定了完善的隐私保护政策。我们使用端到端加密方案，定期进行安全审计和漏洞扫描，7x24小时监控平台运行状态，确保用户数据始终处于安全保护之中。'
  },
  {
    question: '如何在成91平台上创作内容？',
    answer: '在成91平台上创作内容非常便捷。登录后，进入创作中心，您可以使用平台内置的图文编辑器进行内容创作。编辑器支持富文本编辑、多媒体上传、排版美化等功能。完成编辑后，您可以选择发布或保存草稿。平台还会根据您的内容质量给予相应的推荐流量。'
  },
  {
    question: '遇到问题如何联系客服？',
    answer: '成91提供多种客服支持渠道：您可以通过平台内的在线客服系统实时咨询，也可以发送邮件至客服邮箱 support@cheng91.com，或拨打客服热线 400-123-4567。我们的客服团队提供7x24小时全天候服务，平均响应时间仅为3分钟。'
  },
  {
    question: '成91平台支持哪些设备？',
    answer: '成91平台支持所有主流设备和使用场景。您可以通过电脑浏览器访问网页版，也可以通过手机浏览器访问移动网页版。平台采用完全自适应的响应式设计，无论是Windows、Mac、iOS还是Android设备，都能获得优质的使用体验。'
  }
];